import SidebarHeader from "../SidebarHeader";
import SidebarForm from "../SidebarForm";
import nav from "./_nav";
import {Nav} from "reactstrap";
import SidebarFooter from "../SidebarFooter";
import SidebarMinimizer from "../SidebarMinimizer";
import {submenu} from './submenu'
import React, {Fragment} from "react";

export const renderSidebar = (props, states, navList, backToMainMenu) => {
  return (
    <div className="sidebar">

      {states.renderSubMenu ?
        submenu(states.submenuItems, navList, backToMainMenu)
        :
        <Fragment>
          {props.user.customerRef && <SidebarHeader user={props.user} />}
          {props.user.customerRef && <SidebarForm />}
          {props.user.customerRef && (
            <nav className="sidebar-nav">
              <Nav>{states.navsInfo && navList(states.navsInfo.items)}</Nav>
            </nav>
          )}

          {!props.user.customerRef && (
            <nav className="sidebar-nav">
              <Nav>{states.navsInfo && navList(states.navsInfo.itemsInfos)}</Nav>
            </nav>
          )}
          <SidebarFooter />
          <SidebarMinimizer />
        </Fragment>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/renderSidebar.js